import {types} from './types';

const setGetDailyListAction = (payload) => {
    return {
        type: types.SET_LIST,
        payload,
      }
}

const setGetDailyViewAction = (payload) => {
  return {
      type: types.SET_VIEW,
      payload,
    }
}

const setGetLoginAction = (payload) => {
  return {
    type: types.SET_LOGIN,
    payload
  }
}


export {
  setGetDailyListAction,
  setGetDailyViewAction,
  setGetLoginAction
}